import {
  arrayOf,
  shape,
  oneOfType,
  string,
  number,
  bool,
} from 'prop-types';

const optionType = shape({
  value: oneOfType([number, string, bool]),
  label: string.isRequired,
});

export const optionsType = arrayOf(optionType);



// WEBPACK FOOTER //
// ./src/prop-types/selectOptionTypes.js